import { render, staticRenderFns } from "./NavbarMobileComp.vue?vue&type=template&id=4b643f31&scoped=true&"
import script from "./NavbarMobileComp.vue?vue&type=script&lang=js&"
export * from "./NavbarMobileComp.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMobileComp.vue?vue&type=style&index=0&id=4b643f31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b643f31",
  null
  
)

export default component.exports